<template>
  <div class="introduce">
    <div class="introduce-bg"></div>
    <div class="warper clearfix">
      <a-row>
        <a-col :span="18">
          <!-- 文案 -->
          <div class="introduce-text">
            <h1>帮助中心</h1>
            <a-dropdown :trigger="['click', 'change']">
              <a-input
                v-model:value="SearchValue"
                placeholder="请输入关键词搜索相关文档"
                style="width: 400px; margin: 0.5rem 0"
                class="ant-dropdown-link"
                size="large"
                @pressEnter="onSearch"
                @change="onChange"
              >
                <template #suffix>
                  <i class="iconfont icon-search" @click="onSearch"></i>
                </template>
              </a-input>
              <template #overlay>
                <a-menu style="max-height: 50vh; overflow-y: auto">
                  <a-menu-item
                    >查询结果:
                    <span style="color: #2b6afd">{{ searchList.length }}</span
                    >条
                  </a-menu-item>
                  <a-menu-item
                    v-for="item in searchList"
                    :key="item.id"
                    @click="goUrl(item)"
                    >{{ item.title }}</a-menu-item
                  >
                </a-menu>
              </template>
            </a-dropdown>
            <p>
              <span>搜索热词:</span>
              <span @click="hotKey(1)" class="pointer hoverColor"
                >极速智能配置</span
              >
              <span @click="hotKey(2)" class="pointer hoverColor"
                >发布说明</span
              >
            </p>
          </div>
        </a-col>
        <a-col :span="6">
          <img
            style="height: 225px; width: auto"
            src="../assets/icon/bg-icon.png"
          />
        </a-col>
      </a-row>
      <div class="introduce-bottom">
        <a-row type="flex" justify="space-around">
          <a-col @click="sentzhugePoint('快速上手')">
            <!-- <a href="/nocindex/index-noc.html"> -->
            <a href="/help/JiSu">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/quick.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">快速上手</div>
                  <div class="cate-info">极速智能配置来助力</div>
                </a-col>
              </a-row>
            </a>
          </a-col>
          <a-col @click="sentzhugePoint('发布说明')">
            <router-link :to="{ name: 'release' }">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/release.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">发布说明</div>
                  <div class="cate-info">掌握产品最新信息</div>
                </a-col>
              </a-row>
            </router-link>
          </a-col>
          <a-col @click="practiceFun">
            <a href="javascript:;">
              <a-row @click="practiceFun" type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/practice.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">产品体验</div>
                  <div class="cate-info">睿易APP体验入口</div>
                </a-col>
              </a-row>
            </a>
          </a-col>

          <a-col @click="sentzhugePoint('有问必答')">
            <a target="_blank" href="https://ocs.ruijie.com.cn/?p=smb">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/question.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">有问必答</div>
                  <div class="cate-info">专业高效的疑难解答</div>
                </a-col>
              </a-row>
            </a>
          </a-col>
        </a-row>
      </div>
      <a-modal
        v-model="visible"
        cancelText=""
        okText=""
        width="300px"
        height="315px"
        centered
        @ok="handleOk"
        class="Amodal"
      >
        <h1>欢迎体验</h1>
        <!-- <h5>请选择体验产品</h5> -->
        <a-row>
          <!-- <a-col :span="12">
            <a target="_blank" href="/sso/login?service=https%3A%2F%2Fnoc.ruijie.com.cn%2Fadmin3%2F">
              <div class="Amodal-box">
                <h2>MACC诺客云体验</h2>
                <img src="../assets/icon/maccImg.png" />
              </div>
            </a>
          </a-col> -->
          <a-col :span="24">
            <div class="Amodal-box">
              <h2>睿易APP扫码体验</h2>
              <img src="../assets/icon/appImg.png" />
            </div>
          </a-col>
        </a-row>
        <template #footer></template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import { queryArticleList } from "@/utils/query.js";
export default {
  data() {
    return {
      property: "value",
      SearchValue: "",
      visible: false,
      searchList: [],
    };
  },
  methods: {
    goUrl(item) {
      console.log(item);
      let id = String(item.g_id).split("&")[0];
      if (item?.title?.includes("更新说明")) {
        this.$router.push({
          name: "releaseArticle",
          query: { id },
        });
      } else {
        this.$router.push({
          name: "ArticleList",
          query: { id },
        });
      }
    },
    onSearch() {
      if (!this.SearchValue) return;
      this.$router.push({
        name: "ArticleList",
        query: {
          SearchValue: this.SearchValue,
        },
      });
    },
    hotKey(key) {
      let name = "";
      let query = {};
      switch (key) {
        case 1:
          name = "JiSu";
          break;
        case 2:
          name = "release";
          break;
        default:
          name = "ArticleList";
          query.SearchValue = key;
          break;
      }
      this.$router.push({
        name,
        query,
      });
    },
    async onChange() {
      if (this.SearchValue == "") {
        this.searchList = [];
        return;
      }
      this.searchList = [];
      let res = await queryArticleList(this.SearchValue);
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      }
    },
    sentzhugePoint(lv01 = "") {
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
      });
      console.log("macc-help-文档中心-模块统计", lv01);
    },
    practiceFun() {
      this.visible = true;
      this.sentzhugePoint("产品体验");
    },
    handleOk() {},
  },
};
</script>
<style scoped>
/* introduce */
.introduce {
  margin-top: 68px;
  position: relative;
}
.introduce-bg {
  background: url("../assets/icon/bg.png") center no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 249px;
  left: 0;
  top: 0;
  z-index: -1;
}
.introduce-text {
  z-index: -1;
  padding-top: 30px;
  color: rgba(0, 0, 0, 0.45);
}
.introduce-text::v-deep .ant-input {
  border: 0;
  box-shadow: 0px 2px 8px rgba(205, 214, 237, 0.5);
}
.introduce-text .iconfont {
  font-size: 1.5rem;
  color: #2b6afd;
}
.introduce-text h1 {
  font-size: 36px;
  line-height: 50px;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 10px;
}
.introduce-text span {
  display: inline-block;
  font-size: 0.7rem;
  margin-right: 0.5rem;
}

/* introduce-bottom */
.introduce-bottom {
  transform: translateY(-20%);
  z-index: 999 !important;
  box-sizing: border-box;
  padding: 1.5rem 0;
  background: linear-gradient(180deg, #f0f3ff 0%, #ffffff 100%);
  box-shadow: 6px 10px 25px #eceef3;
  border-radius: 6px;
}

.cate-img {
  margin-right: 1rem;
}
.cate-name {
  font-weight: 600;
  font-size: 18px;
  line-height: 2rem;
  color: rgba(0, 0, 0, 0.9);
}
.cate-info {
  font-size: 14px;
  line-height: 2rem;
  color: rgba(0, 0, 0, 0.65);
}

.Amodal {
}
.Amodal h1 {
  text-align: center;
  font-weight: 500;
  line-height: 2rem;
  margin-top: 1rem;
  color: rgba(0, 0, 0, 0.9);
}
.Amodal h5 {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.65);
}
.Amodal::v-deep .ant-modal-footer {
  border: none;
}
.Amodal::v-deep .ant-modal-content {
  background: linear-gradient(360deg, #eaf1ff 0.15%, #ffffff 100%);
}
.Amodal-box {
  text-align: center;
  margin: 1rem;
  height: 199px;
  background: #ffffff;
  border-radius: 8px;
}
.Amodal-box h2 {
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 3rem;
  color: rgba(0, 0, 0, 0.9);
}
</style>
